






























































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import {
  fontFaceList,
  predefineColors,
  formAddList,
  shortFormAddList,
  countdownTimeOption,
  borderRadiusOptions,
  borderStyleOptions,
  typesettingOptions,
  typesettingOptions1,
  fontSizeOptions,
  fontSizeSmallOptions,
  backgroundOptions,
  containerBorderRadiusOptions,
} from '../../../constant/options';
import YcColorPicker from '@/components/color-picker/index.js';
import compontentForm from '../../../components/form.vue';
import { PopSettingsVO, TFormSaveDetailRequest } from '@/model/FormWheel';
import discountDialog from '../../../components/discountDialog.vue';
import { getCompanyInfo } from '@/model/CompanyInfo';
import EventBus from '@/utils/eventBus';
import { getFontFaceList } from '@/utils/getFontFaceList';
import TextAlignPicker from '@/components/text-align/index.vue';
import WheelOptionsCollapse from './WheelOptionsCollapse.vue';
import FontPicker from '@/components/FontPicker/index.vue';
import { getVueAppUploadApi } from '@/services/util';
import { DISABLE_CUSTOM_STEP_TPLID, isEnableAuth, isEnableCustomStep, isEnablePrivacySetting, isEnableWheelCouponSetting } from '@/utils/experiment';
import { getQueryVariable } from '@/services/api';

@Component({
  components: {
    'yc-color-picker': YcColorPicker,
    'compontent-form': compontentForm,
    discountDialog: discountDialog,
    'text-align-picker': TextAlignPicker,
    WheelOptionsCollapse,
    'font-picker': FontPicker
  }
})
export default class wheelOfFortuneTextStart extends Vue {
  @Prop(Object)
  formData!: TFormSaveDetailRequest<PopSettingsVO>;

  @Prop(Number)
  triggerEventType!: any;

  @Prop(Array)
  countryList!: any;

  @Prop(Array)
  pageSettings!: any;

  formDataStart: TFormSaveDetailRequest<PopSettingsVO> = this.formData;
  formList = this.formData.settings?.middle || [];

  // 选择框选项
  get formAddList() {
    if (this.formData.settings.combinationType == 2) {
      return formAddList.filter(item => {
        if (item.label != 'Email') {
          return item;
        }
      });
    } else {
      return formAddList;
    }
  }
  shortFormAddList = shortFormAddList;
  countdownTimeOption = countdownTimeOption;
  predefineColors = predefineColors;
  fontFaceList = getFontFaceList(fontFaceList);
  borderRadiusOptions = borderRadiusOptions;
  borderStyleOptions = borderStyleOptions;
  typesettingOptions = typesettingOptions;
  fontSizeOptions = fontSizeOptions;
  fontSizeSmallOptions = fontSizeSmallOptions;
  backgroundOptions = backgroundOptions;
  typesettingOptions1 = typesettingOptions1;
  containerBorderRadiusOptions = containerBorderRadiusOptions;

  countdownTime: string = 'minute';
  countDown: number = 5;
  collapseArr = ['1', '2'];
  emailOpen: boolean = this.formData.settings.rules.emailOpen === true && this.formData.settings.rules.emailPosition === 'start';
  couponCodeShow: boolean = this.formData.settings.rules.couponCodeShow === true && this.formData.settings.rules.couponCodePosition === 'start';
  compontentFormIsShow = false;
  formType = {};

  uploadUrl = getVueAppUploadApi() + '/upload/formImage';
  uploadDialogVisible = false;
  uploadDialogUrl = '';

  bgUploadFileList: { name: string; url: string }[] = [];
  bgUploadShow = false;
  logoUploadFileList: { name: string; url: string }[] = [];
  logoUploadShow = false;
  leftAdImageFileList: { name: string; url: string }[] = [];
  leftAdImageShow = false;
  rightAdImageFileList: { name: string; url: string }[] = [];
  rightAdImageShow = false;
  textAreaUploadShow = false;
  textAreaFileList: { name: string; url: string }[] = [];

  zpbgUploadFileList: { name: string; url: string }[] = [];
  zpbgUploadShow = false;
  pointUploadFileList: { name: string; url: string }[] = [];
  pointUploadShow = false;

  showDiscountDialog = false;

  // 第三方登录提供商配置
  authProviders = [
    {
      type: 2,
      name: 'Google',
      label: 'Sign in with Google',
      icon: require('@/assets/img/auth/google.svg'),
      placeholder: '请输入 Google Client ID'
    }
  ];

  // wheelOptionsCollapse同步
  onWheelOptionsChange(list: any[]) {
    console.log('onWheelOptionsChange', list);
    this.formDataStart.settings.discountList = list;
    this.changeStart();
  }

  get enableAuth() {
    const tid = `${Number(this.$route.query.templateid) || this.formData.templateId}`;
    const triggerEventType = this.formData.triggerEventType;
    const hasEmail = this.formData.settings.middle?.find(item => item.type === 'Email');
    return isEnableAuth() && hasEmail && (
      (triggerEventType === 2 && tid === '98') ||
      (triggerEventType === 0 && this.formData.type === 'POP_WINDOW')
    );
  }

  get enableMiddleButtonOtherActions() {
    return getCompanyInfo().id === 1291;
  }

  get enableFormOptimize() {
    return true;
  }

  get enableWheelCouponSetting() {
    return isEnableWheelCouponSetting() && this.formDataStart.settings.discountList && this.formDataStart.popWindowWheel === 1;
  }

  get enablePrivacySetting() {
    return isEnablePrivacySetting();
  }

  get enableInputFontFamily() {
    return true;
  }

  get enableSubscribeDifferentPage() {
    return this.formDataStart.successPageType === 1
  }

  get enableMobileRatio() {
    return true;
  }

  get enableCustomStep() {
    if (!isEnableCustomStep() || [3, 5, 6].includes(this.triggerEventType as number)) {
      return false;
    }
    const templateId = String(getQueryVariable('templateid') || this.formDataStart?.templateId || '');
    return !DISABLE_CUSTOM_STEP_TPLID.includes(templateId);
  }

  get company33aPopDisable() {
    const disablePop =
      (JSON.parse(localStorage.getItem('companyInfo') || '{}')?.id == 33 && this.formData?.id == '55abadf02473424aa42004745e4b74f6') ||
      (JSON.parse(localStorage.getItem('companyInfo') || '{}')?.id == 30 && this.formData?.id == '8eaf5e5c7d244b65bc9843e98f33d08d');
    return disablePop;
  }

  get companyis535() {
    const status = JSON.parse(localStorage.getItem('companyInfo') || '{}')?.id === 535;
    return status;
  }

  get shopType() {
    const companyInfo = JSON.parse(localStorage.getItem('companyInfo') || '{}');
    if (companyInfo.shop) {
      if (companyInfo.shop.includes('shopify')) {
        return `shopify`;
      } else if (companyInfo.shop.includes('shopline')) {
        return `shopline`;
      }
    }
    if (companyInfo.integrationType) {
      return companyInfo.integrationType?.toLowerCase();
    }
    return ``;
  }

  get formStyle() {
    const rules = this.formDataStart.settings.rules;
    const styleMap = this.formDataStart.settings.styles.styleMap;
    const textAlignMap: Record<string, string> = {
      'left': 'flex-start',
      'center': 'center',
      'right': 'flex-end',
    };

    console.log('formStyle', rules, styleMap);
    return `
      .cartx-option-columns{
        min-width: ${Math.floor(100 / (rules.middleOptionColumns || 1)) - 3}%!important;
        color: ${rules.middleOptionColor}!important;
      }
      .cartx-option-columns .el-checkbox__input.is-checked .el-checkbox__inner,
      .cartx-option-columns .el-checkbox__input.is-checked .el-radio__inner {
        border-color: ${rules.middleOptionColor}!important;
      }
      .cartx-option-columns .el-checkbox__input.is-checked .el-checkbox__inner,
      .cartx-option-columns .el-radio__input.is-checked .el-radio__inner {
        border-color: ${rules.middleOptionBackground}!important;
        background: ${rules.middleOptionBackground}!important;
      }
      .cartx-question {
        color: ${rules.middleOptionColor}!important;
      }
      .cartx-form .el-input__inner {
        border-width: ${rules.middleInputType === 'bottom' ? '0 0 1px 0' : '1px'}!important;
        border-style: ${rules.middleInputBorderStyle}!important;
        border-color: ${rules.middleInputBorderColor}!important;
        border-radius: ${rules.middleInputBorderRadius}!important;
        background: ${rules.middleInputBackgroundShow !== 'none' ? rules.middleInputBackground : 'none'}!important;
        color: ${rules.middleInputColor}!important;
        ${styleMap['cartx-b-input__middle']['font-family'] ? `font-family: ${styleMap['cartx-b-input__middle']['font-family']} !important;` : ''}
      }
      .cartx-form input::-webkit-input-placeholder {
        color: ${rules.middleInputColor}!important;
        opacity: .3;
      }
      .cartx-form input:-moz-placeholder {
        color: ${rules.middleInputColor}!important;
        opacity: .3;
      }
      .cartx-form input::-moz-placeholder {
        color: ${rules.middleInputColor}!important;
        opacity: .3;
      }
      .cartx-form input:-ms-input-placeholder {
        color: ${rules.middleInputColor}!important;
        opacity: .3;
      }

      ${this.enablePrivacySetting ? `
        .cartx-privacy-new-wrapper {
          color: ${styleMap['cartx-b-privacy__middle']['color']} !important;
          background-color: ${styleMap['cartx-b-privacy__middle']['background-color']} !important;
          margin-top: ${styleMap['cartx-b-privacy__middle']['margin-top'] || 0}px !important;
          margin-bottom: ${styleMap['cartx-b-privacy__middle']['margin-bottom'] || 0 }px  !important;
          margin-left: ${styleMap['cartx-b-privacy__middle']['margin-left'] || 0}px  !important;
          margin-right: ${styleMap['cartx-b-privacy__middle']['margin-right'] || 0}px  !important;
          padding-top: ${styleMap['cartx-b-privacy__middle']['padding-top'] || 0}px !important;
          padding-bottom: ${styleMap['cartx-b-privacy__middle']['padding-bottom'] || 0 }px  !important;
          padding-left: ${styleMap['cartx-b-privacy__middle']['padding-left'] || 0}px  !important;
          padding-right: ${styleMap['cartx-b-privacy__middle']['padding-right'] || 0}px  !important;
          min-width: unset !important;
          border-radius: 4px;
          display: flex;
          flex-direction: column;
          align-items: ${textAlignMap[styleMap['cartx-b-privacy__middle']?.['text-align'] || 'left']};
        }
        .cartx-privacy-new-wrapper .cartx-option-columns.cartx-privacy-new {
          padding: 1px 0;
          border-radius: 0;
          background-color: unset;
          margin: 0;
        }
        .cartx-privacy-new-wrapper .cartx-option-columns.cartx-privacy-new {
          max-height: 43px;
        }
        .cartx-option-columns.cartx-privacy-new .tipsSpan {
          font-family: ${styleMap['cartx-b-privacy__middle']['font-family']} !important;
          font-size: ${styleMap['cartx-b-privacy__middle']['font-size']} !important;
        }
        .cartx-option-columns.cartx-privacy-new .el-checkbox__input {
          height: 14px;
        }
        .cartx-option-columns.cartx-privacy-new .el-checkbox__input .el-checkbox__inner,
        .cartx-option-columns.cartx-privacy-new .el-checkbox__input .el-radio__inner {
          border-color: ${styleMap['cartx-b-privacy__middle']['color']} !important;
        }
        .cartx-option-columns.cartx-privacy-new .el-checkbox__input.is-checked .el-checkbox__inner,
        .cartx-option-columns.cartx-privacy-new .el-radio__input.is-checked .el-radio__inner {
          border-color: ${styleMap['cartx-b-privacy-check__middle']['color']} !important;
          background: ${styleMap['cartx-b-privacy-check__middle']['color']} !important;
        }
        .cartx-option-columns.cartx-privacy-new.cartx-privacy-is-check-box .el-checkbox__input {
          top: 1px
        }
        .cartx-option-columns.cartx-privacy-new .el-checkbox__label {
          flex: 1;
        }
      `: ''}
    `;
  }

  get token() {
    return localStorage.getItem('token') || 'default';
  }

  get showLeftRightAdImage() {
    return ['35', '49'].includes(`${Number(this.$route.query.templateid) || this.formData.templateId}`);
  }

  get isPopZhuanpan() {
    const tid = `${Number(this.$route.query.templateid) || this.formData.templateId}`;
    return (
      this.formData.popWindowWheel === 1 ||
      tid === '36' ||
      tid === '37' ||
      tid === '38' ||
      tid === '39' ||
      tid === '40' ||
      tid === '42' ||
      tid === '43' ||
      `${this.formData.id}` === '1e1609bc024d4517989039886ac7ed34' ||
      `${this.formData.id}` === 'abdac5d809824d8280ffff395a854a15'
    );
  }

  get middleLeftAdImageDisabled() {
    const disabled = this.formDataStart?.settings?.typesetting?.middleLeftAdImage || this.leftAdImageShow;
    return disabled;
  }

  get middleRightAdImageDisabled() {
    const disabled = this.formDataStart?.settings?.typesetting?.middleRightAdImage || this.rightAdImageShow;
    return disabled;
  }

  get showDiscountSetting() {
    return sessionStorage.getItem('isShopify') === '1';
    // const company = JSON.parse(localStorage.getItem('companyInfo') || '{}');
    // const companyId = company?.id;
    // return ((companyId === 30 || companyId === 563 || companyId === 565 || companyId === 577 || companyId === 578 || companyId === 579 || companyId === 580 || companyId === 581 || companyId === 582 || companyId === 680 || companyId === 681)) && this.triggerEventType !== 3;
  }

  gaClickFun(key:string,name:string){
    window?.gtagClick(key,name)
  }

  changeDiscountType() {
    // console.log('changeDiscountType', this.formDataStart.settings.discountType);
    if (this.formDataStart.settings.discountType === 'guding') {
      this.formDataStart.settings.discount = null;
    } else {
      this.showDiscountDialog = true;
    }
    // this.formDataStart.settings.discountType = 'guding';

    // 发送事件通知其他组件
    EventBus.$emit('discount-type-changed', this.formDataStart.settings.discountType);
    this.changeStart();
  }
  showDiscountDialogHandle() {
    this.showDiscountDialog = true;
  }
  saveDiscount(discount: any) {
    this.formDataStart.settings.rules.couponCode = '';
    this.formDataStart.settings.discount = discount;
    this.formDataStart.settings.discountType = 'dongtai';
    // 发送事件通知
    EventBus.$emit('discount-type-changed', 'dongtai');
    this.showDiscountDialog = false;
    this.changeStart();
  }
  closeDiscount() {
    if (this.formDataStart.settings.discountType === 'guding') {
      this.formDataStart.settings.discountType = 'guding';
      this.changeStart();
    }
    this.showDiscountDialog = false;
  }

  changcompontentFormIsShow(e: boolean) {
    this.compontentFormIsShow = e;
  }

  addFormAddList(item: any, index: number) {
    if (this.collapseArr.indexOf('1') < 0) {
      this.collapseArr.push('1');
    }
    if (item.type !== '自定义') {
      let a = this.formList.filter((i: any) => {
        return i.type === item.type;
      });

      if (a.length > 0) {
        this.formType = a[0];
        this.compontentFormIsShow = true;
        return;
      }
      // 检查其他步骤页是否存在相同表单
      let b =
        [
          ...(this.formDataStart.settings.start || []),
          ...(this.formDataStart.settings.end || [])
        ].filter((i: any) => {
          return i.type === item.type;
        }) || [];
      if (b.length > 0) {
        this.$message.error('您添加了多个' + item.label + '表单，请检查设置是否有误');
        return;
      }
    }

    if (this.formList.length < 8) {
      this.formType = item;
      this.compontentFormIsShow = true;
    } else {
      this.$message.error('最多只能添加8个表单');
    }
    window?.gtagClick('form_edit_selectField_'+item?.label.replace(/\s/g, ''),'弹窗_编辑订阅工具_选择采集项_'+item?.label.replace(/\s/g, ''))
  }

  //倒计时计算
  changecountDownShow() {
    if (this.countdownTime === 'minute') {
      this.formDataStart.settings.rules.countDown = this.countDown * 60;
    } else if (this.countdownTime === 'second') {
      this.formDataStart.settings.rules.countDown = this.countDown;
    }
    window?.gtagClick('form_edit_CountdownTimerEditor', '弹窗_编辑订阅工具_设置倒计时器组件');
    this.changeStart();
  }

  changeFormList(e: any) {
    this.formDataStart.settings.middle = e;
    if (this.stepDisplayDisabled) {
      Vue.set(this.formDataStart.settings.rules, 'stepDisplay', false);
    }
    this.changeStart();
  }

  changeImgPosition() {
    if (this.formDataStart?.settings?.typesetting?.middleImgPosition != 'background') {
      this.formDataStart.settings.typesetting.middleBgbox = false;
    }
    this.changeStart();
  }

  changeStart() {
    this.$forceUpdate();
    this.$emit('change', this.formDataStart);
    window?.gtagClick('form_edit_setCloseButton','弹窗_编辑订阅工具_设置关闭按钮')
  }

  changeStartGA() {
    this.$forceUpdate();
    this.$emit('change', this.formDataStart);
    window?.gtagClick('form_edit_setCloseButton','弹窗_编辑订阅工具_设置关闭按钮')
  }

  changeStartWithGtag(key: string, name: string) {
    this.$forceUpdate();
    this.$emit('change', this.formDataStart);
    window?.gtagClick(key, name);
  }

  changeCouponCodePosition() {
    if (this.couponCodeShow) {
      if (this.formData.settings.rules.couponCodePosition === 'end') {
        this.$message.warning('结束页面已经展示coupon');
        this.couponCodeShow = false;
      } else {
        this.formDataStart.settings.rules.couponCodePosition = 'start';
        this.formDataStart.settings.rules.couponCodeShow = this.couponCodeShow;
      }
    } else {
      if (this.formData.settings.rules.couponCodePosition === 'end') {
        this.formDataStart.settings.rules.couponCodePosition = 'end';
      } else {
        this.formDataStart.settings.rules.couponCodePosition = '';
      }
    }
    this.changeStart();
  }

  changeCouponCodeType() {
    this.changeStart();
  }

  blurPointDeg() {
    if (!this.formDataStart.settings.rules.pointFinallyDeg) {
      this.formDataStart.settings.rules.pointFinallyDeg = 0;

      const input = document.querySelector('.wheel-setting-deg-input input');
      if (input) {
        input.value = '0';
      }
    }
  }

  changePointDeg() {
    if (!this.formDataStart.settings.rules.pointFinallyDeg) {
      this.formDataStart.settings.rules.pointFinallyDeg = 0;

      const input = document.querySelector('.wheel-setting-deg-input input');
      if (input) {
        input.value = '0';
      }
    }
    this.changeStart();
  }

  get stepDisplayDisabled() {
    return (
      this.formData.settings.start?.reduce(
        (info, form, index, arr) => {
          // 仅包含'Email'和'Mobile Number'时可以勾选；
          if (form.type === 'Email' || form.type === 'Mobile Number') {
            info.ok.add(form.type);
          } else {
            info.err.add(form.type);
          }
          let newdisabled = true;
          if (arr.length == 2) {
            newdisabled = !(arr[0]?.type == 'Email' && arr[1]?.type == 'Mobile Number');
          } else {
            newdisabled = info.ok.size !== 2 || info.err.size !== 0;
          }
          info.disabled = newdisabled;
          return info;
        },
        { ok: new Set(), err: new Set(), disabled: true }
      ).disabled ||
      !this.formData.settings.end ||
      this.formData.settings.end.length !== 0
    );
  }

  // 当开始页按钮交互切换为“显示下一步骤”或其他选项时，更新页面设置
  handleButtonActionChange() {
    const action = this.formDataStart?.settings?.rules?.middleButtonAction;

    if (action === 'open') {
      this.pageSettings.forEach((item: any) => {
        if (item.value === 'end') {
          // 启用结束页：恢复不透明度
          item.opacity = 1;
        }
      });
    } else {
      this.pageSettings.forEach((item: any) => {
        if (item.value === 'end') {
          // 禁用结束页：降低不透明度
          item.opacity = 0.3;
        }
      });
    }

    this.changeStart();
  }

  @Watch('formData.settings.typesetting.middleImgUrl', { immediate: true })
  typesettingImgUrlChange(val: string) {
    if (val) {
      this.bgUploadShow = true;
      this.bgUploadFileList = [
        {
          name: '',
          url: val
        }
      ];
    }
  }
  @Watch('formData.settings.typesetting.middleBgImgUrl', { immediate: true })
  typesettingBGImgUrlChange(val: string) {
    if (val) {
      this.zpbgUploadShow = true;
      this.zpbgUploadFileList = [
        {
          name: '',
          url: val
        }
      ];
    }
  }
  @Watch('formData.settings.typesetting.pointImgUrl', { immediate: true })
  typesettingPointImgUrlChange(val: string) {
    if (val) {
      this.pointUploadShow = true;
      this.pointUploadFileList = [
        {
          name: '',
          url: val
        }
      ];
    }
  }

  @Watch('formData.settings.logo.middleImgUrl', { immediate: true })
  logoImgUrlChange(val: string) {
    if (val) {
      this.logoUploadShow = true;
      this.logoUploadFileList = [
        {
          name: '',
          url: val
        }
      ];
    }
  }

  @Watch('formData.settings.typesetting.middleLeftAdImage', { immediate: true })
  leftAdImageUrlChange(val: string) {
    if (val) {
      this.leftAdImageShow = true;
      this.leftAdImageFileList = [
        {
          name: '',
          url: val
        }
      ];
    }
  }

  @Watch('formData.settings.typesetting.middleRightAdImage', { immediate: true })
  rightAdImageUrlChange(val: string) {
    if (val) {
      this.rightAdImageShow = true;
      this.rightAdImageFileList = [
        {
          name: '',
          url: val
        }
      ];
    }
  }

  @Watch('formData.settings.texts.middleTextAreaImgUrl', { immediate: true })
  textAreaImgUrlChange(val: string) {
    if (val) {
      this.textAreaUploadShow = true;
      this.textAreaFileList = [
        {
          name: '',
          url: val
        }
      ];
    }
  }

  @Watch('formData.settings.rules.emailOpen')
  emailOpenChange(val: boolean) {
    if (val === true && this.formData.settings.rules.emailPosition === 'start') {
      this.emailOpen = true;
    } else {
      this.emailOpen = false;
      if (this.formData.settings.rules.emailPosition === 'end') {
        this.formDataStart.settings.rules.emailPosition = 'end';
      } else {
        this.formDataStart.settings.rules.emailPosition = '';
      }
    }
  }

  @Watch('formData.settings.rules.emailPosition')
  emailPositionChange(val: string) {
    this.emailOpen = this.formData.settings.rules.emailOpen === true && val === 'start';
  }

  @Watch('formData.settings.rules.couponCodeShow')
  couponCodeShowChange(val: boolean) {
    this.couponCodeShow = val === true && this.formData.settings.rules.couponCodePosition === 'start';
  }

  @Watch('formData.settings.rules.couponCodePosition')
  couponCodePositionChange(val: string) {
    this.couponCodeShow = this.formData.settings.rules.couponCodeShow === true && val === 'start';
  }

  mounted() {
    if (!!this.formDataStart.settings.rules.couponCode || !this.formDataStart.settings.discount) {
      this.formDataStart.settings.discountType = 'guding';
    } else {
      this.formDataStart.settings.discountType = 'dongtai';
    }

    // 设置移动端广告位比例默认值（$set 保证响应式，触发 popNew 预览更新）
    if (!this.formDataStart.settings.rules.middleMobileRatio && this.enableMobileRatio) {
      this.$set(this.formDataStart.settings.rules as any, 'middleMobileRatio', 'recommendRatio');
    }

    // 确保中间页倒计时开关字段是响应式的（用于预览实时生效）
    if (typeof this.formDataStart.settings.rules.middleCountDownShow === 'undefined') {
      this.$set(
        this.formDataStart.settings.rules as any,
        'middleCountDownShow',
        this.formDataStart.settings.rules.countDownShow ?? false
      );
    }

    // 确保 authList 存在
    if (!this.formDataStart.settings.authList) {
      this.$set(this.formDataStart.settings, 'authList', []);
    }
  }

  @Watch('formData')
  changeFormData() {
    this.formDataStart = this.formData;
    // if (!this.formDataStart.settings.discountType) {
    if (!!this.formDataStart.settings.rules.couponCode || !this.formDataStart.settings.discount) {
      this.formDataStart.settings.discountType = 'guding';
    } else {
      this.formDataStart.settings.discountType = 'dongtai';
    }
    
    // 设置移动端广告位比例默认值（$set 保证响应式，触发 popNew 预览更新）
    if (!this.formDataStart.settings.rules.middleMobileRatio && this.enableMobileRatio) {
      this.$set(this.formDataStart.settings.rules as any, 'middleMobileRatio', 'recommendRatio');
    }
    // }
  }
  @Watch('formData.settings.rules.countDown')
  changeCountDown(val: number) {
    if (val > 60) {
      this.countDown = val / 60;
      this.countdownTime = 'minute';
    } else if (val === 60) {
      this.countdownTime = 'second';
      this.$nextTick(() => {
        this.countDown = 60 / 1;
      });
    } else {
      this.countdownTime = 'second';
      this.countDown = val;
    }
  }

  @Watch('formData.settings.start')
  changeStartFormList(val: any) {
    this.formList = val;
  }

  @Watch('formData.settings.middle', { immediate: true })
  changeMiddleFormList(val: any) {
    if (val && val.length > 0) {
      this.formList = val;
    }
  }

  @Watch('formData.settings.rules.middlePrivacyPosition')
  privacyPositionChange(val: string) {
    const styleMap = this.formDataStart.settings.styles.styleMap['cartx-b-privacy__middle'];
    // 嵌入弹窗都在button下面
    if (val === 'form' && this.formDataStart.triggerEventType !== 7) {
      // 跟随采集框：下间距6px，上间距0
      styleMap['margin-bottom'] = 6;
      styleMap['margin-top'] = 0;
    } else if (val === 'button' || this.formDataStart.triggerEventType === 7) {
      // 主按钮以下：下间距0，上间距6px
      styleMap['margin-bottom'] = 0;
      styleMap['margin-top'] = 6;
    }
  }

  /**
   * 图片上传失败钩子函数
   */
  bgHandleError(e: any): void {
    this.bgUploadShow = false;
    this.$message.warning('图片上传失败！');
    if (e.data && e.data.code === 401) {
      // 如果返回401 即没有权限，跳到登录页重新登录
      this.$alert('登录失效，请重新登录');
      // this.$router.replace({
      //   path: "/login",
      //   query: { redirect: this.$router.currentRoute.fullPath },
      // });
      window.location.href = '/cartsee-new/login?redirect=' + encodeURIComponent(this.$router.currentRoute.fullPath);
    }
    this.changeStart();
  }
  /**
   * 图片上传成功钩子函数
   */
  bgHandleSuccess(res: { data: { url: string; message: string }[] }, file: any, fileList: any): void {
    this.bgUploadShow = true;
    if (res.data[0].url && !res.data[0].message) {
      this.formDataStart?.settings?.typesetting && (this.formDataStart.settings.typesetting.middleImgUrl = res.data[0].url);
      this.bgUploadFileList = res.data[0].url ? [{ name: '', url: res.data[0].url }] : [];
      this.$forceUpdate();
    } else {
      fileList.splice(0, fileList.length);
      this.bgUploadShow = false;
      this.$message.warning(res.data[0].message);
    }
    this.changeStart();
  }
  /**
   * 图片上传前钩子函数
   */
  bgBeforeUpload(file: { type: string; size: number }): boolean {
    const isIMAGE =
      file.type === "image/jpeg" ||
      file.type === "image/gif" ||
      file.type === "image/webp" ||
      file.type === "image/png" ||
      file.type === "image/jpg";
    if (!isIMAGE) {
      this.$message.error('上传文件只能是图片格式!');
      return false;
    }
    if (file.size / 1024 > 500) {
      this.$message.error('上传的图片大小不超过500kb');
      return false;
    }
    this.bgUploadShow = true;
    return true;
  }
  /**
   * 删除图片
   */
  bgUploadUrlDelete() {
    this.bgUploadShow = false;
    this.formDataStart?.settings?.typesetting && (this.formDataStart.settings.typesetting.middleImgUrl = '');
  }

  /**
   * 图片上传失败钩子函数
   */
  zpbgHandleError(e: any): void {
    this.zpbgUploadShow = false;
    this.$message.warning('图片上传失败！');
    if (e.data && e.data.code === 401) {
      // 如果返回401 即没有权限，跳到登录页重新登录
      this.$alert('登录失效，请重新登录');
      // this.$router.replace({
      //   path: "/login",
      //   query: { redirect: this.$router.currentRoute.fullPath },
      // });
      window.location.href = '/cartsee-new/login?redirect=' + encodeURIComponent(this.$router.currentRoute.fullPath);
    }
    this.changeStart();
  }
  /**
   * 图片上传成功钩子函数
   */
  zpbgHandleSuccess(res: { data: { url: string; message: string }[] }, file: any, fileList: any): void {
    this.zpbgUploadShow = true;
    if (res.data[0].url && !res.data[0].message) {
      if (this.formDataStart?.settings?.typesetting) {
        // 使用 Vue.set / this.$set 确保 middleBgImgUrl 响应式，触发 popNew 重新渲染
        this.$set(this.formDataStart.settings.typesetting as any, 'middleBgImgUrl', res.data[0].url);
      }
      this.zpbgUploadFileList = res.data[0].url ? [{ name: '', url: res.data[0].url }] : [];
      this.$forceUpdate();
    } else {
      fileList.splice(0, fileList.length);
      this.zpbgUploadShow = false;
      this.$message.warning(res.data[0].message);
    }
    this.changeStart();
  }
  /**
   * 图片上传前钩子函数
   */
  zpbgBeforeUpload(file: { type: string; size: number }): boolean {
    const isIMAGE = file.type === 'image/jpeg' || file.type === 'image/gif' || file.type === 'image/webp' || file.type === 'image/png';
    if (!isIMAGE) {
      this.$message.error('上传文件只能是图片格式!');
      return false;
    }
    if (file.size / 1024 > 500) {
      this.$message.error('上传的图片大小不超过500kb');
      return false;
    }
    this.zpbgUploadShow = true;
    return true;
  }
  /**
   * 删除图片
   */
  zpbgUploadUrlDelete() {
    this.zpbgUploadShow = false;
    if (this.formDataStart?.settings?.typesetting) {
      // 删除时同样用 this.$set，保证值变更是响应式的
      this.$set(this.formDataStart.settings.typesetting as any, 'middleBgImgUrl', '');
    }
  }

  /**
   * 图片上传失败钩子函数
   */
  pointHandleError(e: any): void {
    this.pointUploadShow = false;
    this.$message.warning('图片上传失败！');
    if (e.data && e.data.code === 401) {
      // 如果返回401 即没有权限，跳到登录页重新登录
      this.$alert('登录失效，请重新登录');
      // this.$router.replace({
      //   path: "/login",
      //   query: { redirect: this.$router.currentRoute.fullPath },
      // });
      window.location.href = '/cartsee-new/login?redirect=' + encodeURIComponent(this.$router.currentRoute.fullPath);
    }
    this.changeStart();
  }
  /**
   * 图片上传成功钩子函数
   */
  pointHandleSuccess(res: { data: { url: string; message: string }[] }, file: any, fileList: any): void {
    this.pointUploadShow = true;
    if (res.data[0].url && !res.data[0].message) {
      this.formDataStart?.settings?.typesetting && (this.formDataStart.settings.typesetting.pointImgUrl = res.data[0].url);
      this.pointUploadFileList = res.data[0].url ? [{ name: '', url: res.data[0].url }] : [];
      this.$forceUpdate();
    } else {
      fileList.splice(0, fileList.length);
      this.pointUploadShow = false;
      this.$message.warning(res.data[0].message);
    }
    this.changeStart();
  }
  /**
   * 图片上传前钩子函数
   */
  pointBeforeUpload(file: { type: string; size: number }): boolean {
    const isIMAGE = file.type === 'image/jpeg' || file.type === 'image/gif' || file.type === 'image/webp' || file.type === 'image/png';
    if (!isIMAGE) {
      this.$message.error('上传文件只能是图片格式!');
      return false;
    }
    if (file.size / 1024 > 500) {
      this.$message.error('上传的图片大小不超过500kb');
      return false;
    }
    this.pointUploadShow = true;
    return true;
  }
  /**
   * 删除图片
   */
  pointUploadUrlDelete() {
    this.pointUploadShow = false;
    this.formDataStart?.settings?.typesetting && (this.formDataStart.settings.typesetting.pointImgUrl = '');
  }

  /**
   * 图片上传失败钩子函数
   */
  logoHandleError(e: any): void {
    this.logoUploadShow = false;
    this.$message.warning('图片上传失败！');
    if (e.data && e.data.code === 401) {
      // 如果返回401 即没有权限，跳到登录页重新登录
      this.$alert('登录失效，请重新登录');
      // this.$router.replace({
      //   path: "/login",
      //   query: { redirect: this.$router.currentRoute.fullPath },
      // });
      window.location.href = '/cartsee-new/login?redirect=' + encodeURIComponent(this.$router.currentRoute.fullPath);
    }
    this.changeStart();
  }
  /**
   * 图片上传成功钩子函数
   */
  logoHandleSuccess(res: { data: { url: string; message: string }[] }, file: any, fileList: any): void {
    this.logoUploadShow = true;
    if (res.data[0].url && !res.data[0].message) {
      this.formDataStart?.settings?.logo && (this.formDataStart.settings.logo.middleImgUrl = res.data[0].url);
      this.logoUploadFileList = res.data[0].url ? [{ name: '', url: res.data[0].url }] : [];
      this.$forceUpdate();
    } else {
      fileList.splice(0, fileList.length);
      this.logoUploadShow = false;
      this.$message.warning(res.data[0].message);
    }
    this.changeStart();
  }
  /**
   * 图片上传前钩子函数
   */
  logoBeforeUpload(file: { type: string; size: number }): boolean {
    const isIMAGE = file.type === 'image/jpeg' || file.type === 'image/gif' || file.type === 'image/webp' || file.type === 'image/png';
    if (!isIMAGE) {
      this.$message.error('上传文件只能是图片格式!');
      return false;
    }
    if (file.size / 1024 > 500) {
      this.$message.error('上传的图片大小不超过500kb');
      return false;
    }
    this.logoUploadShow = true;
    return true;
  }
  /**
   * 删除图片
   */
  logoUploadUrlDelete() {
    this.logoUploadShow = false;
    this.formDataStart?.settings?.logo && (this.formDataStart.settings.logo.middleImgUrl = '');
  }

  // 左图上传

  /**
   * 图片上传失败钩子函数
   */
  leftAdImageHandleError(e: any): void {
    this.leftAdImageShow = false;
    this.$message.warning('图片上传失败！');
    if (e.data && e.data.code === 401) {
      // 如果返回401 即没有权限，跳到登录页重新登录
      this.$alert('登录失效，请重新登录');
      // this.$router.replace({
      //   path: "/login",
      //   query: { redirect: this.$router.currentRoute.fullPath },
      // });
      window.location.href = '/cartsee-new/login?redirect=' + encodeURIComponent(this.$router.currentRoute.fullPath);
    }
    this.changeStart();
  }
  /**
   * 图片上传成功钩子函数
   */
  leftAdImageHandleSuccess(res: { data: { url: string; message: string }[] }, file: any, fileList: any): void {
    this.leftAdImageShow = true;
    if (res.data[0].url && !res.data[0].message) {
      this.formDataStart?.settings?.typesetting && (this.formDataStart.settings.typesetting.middleLeftAdImage = res.data[0].url);
      this.leftAdImageFileList = res.data[0].url ? [{ name: '', url: res.data[0].url }] : [];
      this.$forceUpdate();
    } else {
      fileList.splice(0, fileList.length);
      this.leftAdImageShow = false;
      this.$message.warning(res.data[0].message);
    }
    this.changeStart();
  }
  /**
   * 图片上传前钩子函数
   */
  leftAdImageBeforeUpload(file: { type: string; size: number }): boolean {
    const isIMAGE = file.type === 'image/jpeg' || file.type === 'image/gif' || file.type === 'image/webp' || file.type === 'image/png';
    if (!isIMAGE) {
      this.$message.error('上传文件只能是图片格式!');
      return false;
    }
    if (file.size / 1024 > 500) {
      this.$message.error('上传的图片大小不超过500kb');
      return false;
    }
    this.leftAdImageShow = true;
    return true;
  }
  /**
   * 删除图片
   */
  leftAdImageUrlDelete() {
    this.leftAdImageShow = false;
    this.formDataStart?.settings?.typesetting && (this.formDataStart.settings.typesetting.middleLeftAdImage = '');
    this.changeStart();
  }

  // 右图上传

  /**
   * 图片上传失败钩子函数
   */
  rightAdImageHandleError(e: any): void {
    this.rightAdImageShow = false;
    this.$message.warning('图片上传失败！');
    if (e.data && e.data.code === 401) {
      // 如果返回401 即没有权限，跳到登录页重新登录
      this.$alert('登录失效，请重新登录');
      // this.$router.replace({
      //   path: "/login",
      //   query: { redirect: this.$router.currentRoute.fullPath },
      // });
      window.location.href = '/cartsee-new/login?redirect=' + encodeURIComponent(this.$router.currentRoute.fullPath);
    }
    this.changeStart();
  }
  /**
   * 图片上传成功钩子函数
   */
  rightAdImageHandleSuccess(res: { data: { url: string; message: string }[] }, file: any, fileList: any): void {
    this.rightAdImageShow = true;
    if (res.data[0].url && !res.data[0].message) {
      this.formDataStart?.settings?.typesetting && (this.formDataStart.settings.typesetting.middleRightAdImage = res.data[0].url);
      this.rightAdImageFileList = res.data[0].url ? [{ name: '', url: res.data[0].url }] : [];
      this.$forceUpdate();
    } else {
      fileList.splice(0, fileList.length);
      this.rightAdImageShow = false;
      this.$message.warning(res.data[0].message);
    }
    this.changeStart();
  }
  /**
   * 图片上传前钩子函数
   */
  rightAdImageBeforeUpload(file: { type: string; size: number }): boolean {
    const isIMAGE = file.type === 'image/jpeg' || file.type === 'image/gif' || file.type === 'image/webp' || file.type === 'image/png';
    if (!isIMAGE) {
      this.$message.error('上传文件只能是图片格式!');
      return false;
    }
    if (file.size / 1024 > 500) {
      this.$message.error('上传的图片大小不超过500kb');
      return false;
    }
    this.rightAdImageShow = true;
    return true;
  }
  /**
   * 删除图片
   */
  rightAdImageUrlDelete() {
    this.rightAdImageShow = false;
    this.formDataStart?.settings?.typesetting && (this.formDataStart.settings.typesetting.middleRightAdImage = '');
    this.changeStart();
  }

  uploadUrlPreview(file: any) {
    this.uploadDialogUrl = file.url;
    this.uploadDialogVisible = true;
  }

  /**
   * 图片上传失败钩子函数
   */
  textAreaHandleError(e: any): void {
    this.textAreaUploadShow = false;
    this.$message.warning('图片上传失败！');
    if (e.data && e.data.code === 401) {
      // 如果返回401 即没有权限，跳到登录页重新登录
      this.$alert('登录失效，请重新登录');
      // this.$router.replace({
      //   path: "/login",
      //   query: { redirect: this.$router.currentRoute.fullPath },
      // });
      window.location.href = '/cartsee-new/login?redirect=' + encodeURIComponent(this.$router.currentRoute.fullPath);
    }
    this.changeStart();
  }
  /**
   * 图片上传成功钩子函数
   */
  textAreaHandleSuccess(res: { data: { url: string; message: string }[] }, file: any, fileList: any): void {
    this.textAreaUploadShow = true;
    if (res.data[0].url && !res.data[0].message) {
      if (this.formDataStart?.settings?.texts) {
        // 使用 Vue.set / this.$set 确保 middleTextAreaImgUrl 响应式，触发 popNew 重新渲染
        this.$set(this.formDataStart.settings.texts as any, 'middleTextAreaImgUrl', res.data[0].url);
      }
      this.textAreaFileList = res.data[0].url ? [{ name: '', url: res.data[0].url }] : [];
      this.$forceUpdate();
    } else {
      fileList.splice(0, fileList.length);
      this.textAreaUploadShow = false;
      this.$message.warning(res.data[0].message);
    }
    this.changeStart();
  }
  /**
   * 图片上传前钩子函数
   */
  textAreaBeforeUpload(file: { type: string; size: number }): boolean {
    const isIMAGE = file.type === 'image/jpeg' || file.type === 'image/gif' || file.type === 'image/webp' || file.type === 'image/png';
    if (!isIMAGE) {
      this.$message.error('上传文件只能是图片格式!');
      return false;
    }
    if (file.size / 1024 > 500) {
      this.$message.error('上传的图片大小不超过500kb');
      return false;
    }
    this.textAreaUploadShow = true;
    return true;
  }
  /**
   * 删除图片
   */
  textAreaUploadUrlDelete() {
    this.textAreaUploadShow = false;
    if (this.formDataStart?.settings?.texts) {
      // 删除时同样用 this.$set，保证值变更是响应式的
      this.$set(this.formDataStart.settings.texts as any, 'middleTextAreaImgUrl', '');
    }
    this.changeStart();
  }
  /**
   * 点击上传图片
   */
  textAreaClick() {
    window.gtagClick('form_edit_setTextImage', '弹窗_编辑订阅工具_设置文本区域图片');
  }

  /**
   * 检查某个登录方式是否已启用
   */
  isAuthEnabled(type: number): boolean {
    return this.formDataStart.settings.authList?.some(auth => auth.type === type) || false;
  }

  /**
   * 获取某个登录方式的 clientId
   */
  getAuthClientId(type: number): string {
    return this.formDataStart.settings.authList?.find(auth => auth.type === type)?.clientId || '';
  }

  /**
   * 切换登录方式启用状态
   */
  toggleAuthProvider(type: number, enabled: boolean) {
    if (!this.formDataStart.settings.authList) {
      this.$set(this.formDataStart.settings, 'authList', []);
    }
    
    if (enabled) {
      // 启用：添加到 authList
      if (!this.isAuthEnabled(type) && this.formDataStart.settings.authList) {
        this.formDataStart.settings.authList.push({
          type: type,
          clientId: ''
        });
      }
    } else {
      // 禁用：从 authList 中移除
      if (this.formDataStart.settings.authList) {
        const index = this.formDataStart.settings.authList.findIndex(auth => auth.type === type);
        if (index > -1) {
          this.formDataStart.settings.authList.splice(index, 1);
        }
      }
    }

    window.gtagClick('form_edit_signinwithGoogle', '弹窗_编辑订阅工具勾选google登录');
    this.changeStart();
  }

  /**
   * 更新 clientId
   */
  updateAuthClientId(type: number, clientId: string) {
    if (!this.formDataStart.settings.authList) {
      return;
    }
    const auth = this.formDataStart.settings.authList.find(auth => auth.type === type);
    if (auth) {
      auth.clientId = clientId;
      this.changeStart();
    }
  }

  /**
   * 校验 Google Client ID 格式
   * 只校验结尾是否为 .apps.googleusercontent.com
   */
  isValidGoogleClientId(clientId: string): boolean {
    return clientId.trim().endsWith('.apps.googleusercontent.com');
  }

  /**
   * 校验第三方登录配置
   * 如果启用了第三方登录，需要校验：
   * 1. clientId 是否已填写
   * 2. clientId 格式是否正确
   * 3. 是否有 email 采集项
   */
  validateAuthList(): boolean {
    if (!this.formDataStart.settings.authList || this.formDataStart.settings.authList.length === 0) {
      return true; // 没有启用第三方登录，校验通过
    }

    // 校验每个启用的第三方登录
    for (const auth of this.formDataStart.settings.authList) {
      // 1. 校验 clientId 是否已填写
      if (!auth.clientId || auth.clientId.trim() === '') {
        this.$message.error({
          message: '您已勾选添加第三方登录按钮，请输入Google client ID，再进行下一步操作',
          type: 'error',
          duration: 5000
        });
        return false;
      }

      // 2. 校验 clientId 格式是否正确
      if (!this.isValidGoogleClientId(auth.clientId)) {
        this.$message.error({
          message: 'Google Client ID 格式不正确，应为：xxx.apps.googleusercontent.com',
          type: 'error',
          duration: 5000
        });
        return false;
      }

      // 3. 校验是否有 email 采集项
      const hasEmail = this.formList.some((form: any) => form.type === 'Email');
      if (!hasEmail) {
        this.$message.error({
          message: '您已勾选添加第三方登录按钮，请添加Email表单后，再进行下一步操作',
          type: 'error',
          duration: 5000
        });
        return false;
      }
    }

    return true;
  }
}
